import { RecoilRoot } from 'recoil'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { client } from './config/apolloClient'
import { GlobalStyle } from './layout/globalStyle'
import MainRouter from './router/index'
import { AuthProvider } from './context/AuthProvider'

function App() {
  return (
    <RecoilRoot>
      <AuthProvider>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <GlobalStyle />
            <MainRouter />
          </BrowserRouter>
        </ApolloProvider>
      </AuthProvider>
    </RecoilRoot>
  )
}

export default App
